'use strict';

var endpoints = require('dibs-endpoints');

var _require = require('./util'),
    fetchWrapper = _require.fetchWrapper,
    addHeaders = _require.addHeaders,
    addTokenToUrl = _require.addTokenToUrl,
    addParamsToUrl = _require.addParamsToUrl,
    conditionalPromiseHelpers = _require.conditionalPromiseHelpers;

// statuses


var STATUS_CONNECTED = 'CONNECTED';

var INSTAGRAM = 'INSTAGRAM';
var SOCIAL_NETWORKS = [INSTAGRAM];

/**
 * Sends a GET request to the identity service to get geography data
 * @returns {Promise}
 */
function getGeography() {
    return fetchWrapper(endpoints.geography(), addHeaders({ method: 'get' }));
}

/**
 * Sends GET request to the identity service to get a list of address objects
 * @param {Object} params
 * @returns {Promise}
 */
function resolveZip(params) {
    return fetchWrapper(addParamsToUrl(endpoints.zipCode(), params), addHeaders({ method: 'get' }));
}

/**
 * Get a Portfolio by its id
 *
 * @param {String} id
 * @param {Object} [params]
 * @param {Number} [params.numItemPreviews]
 * @param {String} [params.pageType]        - 'saturdayShopper' or 'portfolio'
 * @param {String} [params.loadItems]       - Y/N
 * @param {String} [params.loadHierarchy]   - Y/N (Y when numItemPreviews > 1)
 * @param {String} [params.loadItemCounts]  - Y/N
 * @returns {Promise}
 */
function getPortfolioById(id, params) {
    return fetchWrapper(addTokenToUrl(endpoints.portfolio(id), params), addHeaders({ method: 'get' }));
}

/**
 * Get Favorites Portfolio of a given user
 *
 * @param {Number} userId
 * @param {Object} [params]
 * @param {String} [params.loadItems]
 * @param {String} [params.loadItemCounts]
 * @param {Number} [params.numItemPreviews]
 * @returns {Promise}
 */
function getPortfolioByUserId(userId, params) {
    return fetchWrapper(addTokenToUrl(endpoints.portfoliosByUser(userId), params), addHeaders({ method: 'get' }));
}

/**
 * Add Social Network to User
 *
 * @param   {Number} userId
 * @param   {Object}  payload
 * @returns {Promise}
 */
function addSocialNetwork(userId, payload) {
    return fetchWrapper(addTokenToUrl(endpoints.addUserSocialNetwork(userId)), addHeaders({
        method: 'post',
        body: JSON.stringify(payload)
    }));
}

// Constants Social Networks
exports.SOCIAL_NETWORKS = {
    instagram: INSTAGRAM
};

/**
 * Constructs a socialNetwork Object
 * @returns {object}
 */
function defaultSocialNetwork(_ref) {
    var name = _ref.name;

    return {
        apiType: 'socialNetwork',
        name: name
    };
}

/**
 * Gets ordered lists of countries and us states from the identity service
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.getCountriesAndStates = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$onStart = _ref2.onStart,
        onStart = _ref2$onStart === undefined ? function () {} : _ref2$onStart,
        _ref2$onSuccess = _ref2.onSuccess,
        onSuccess = _ref2$onSuccess === undefined ? function () {} : _ref2$onSuccess,
        _ref2$onFail = _ref2.onFail,
        onFail = _ref2$onFail === undefined ? function () {} : _ref2$onFail;

    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe.ok,
            fail = _conditionalPromiseHe.fail;

        // Make request and handle response


        onStart();
        return getGeography().then(function (response) {
            var _response$result$geog = response.result.geography,
                countries = _response$result$geog.countries,
                usStates = _response$result$geog.usStates;

            ok({ countries: countries, usStates: usStates });
        }).catch(fail);
    });
};

/**
 * Returns an address based on zipCode and country
 *
 * @param   {Object}  payload
 * @param   {String}  payload.zipCode
 * @param   {String}  payload.country
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.resolveZip = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref3.payload,
        _ref3$onStart = _ref3.onStart,
        onStart = _ref3$onStart === undefined ? function () {} : _ref3$onStart,
        _ref3$onSuccess = _ref3.onSuccess,
        onSuccess = _ref3$onSuccess === undefined ? function () {} : _ref3$onSuccess,
        _ref3$onFail = _ref3.onFail,
        onFail = _ref3$onFail === undefined ? function () {} : _ref3$onFail;

    var _ref4 = payload || {},
        zipCode = _ref4.zipCode,
        country = _ref4.country;

    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe2 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe2.ok,
            fail = _conditionalPromiseHe2.fail,
            failIfAny = _conditionalPromiseHe2.failIfAny;

        var possibleErrors = [[!zipCode, { message: 'Required String parameter \'zipCode\' is not present' }], [!country, { message: 'Required String parameter \'country\' is not present' }]];

        // fail and return if there are errors
        if (failIfAny(possibleErrors)) {
            return;
        }

        // Make request and handle response
        onStart({ zipCode: zipCode, country: country });
        return resolveZip({ zipCode: zipCode, country: country }).then(function (response) {
            ok({ addresses: response.result.list.dataList });
        }).catch(fail);
    });
};

/**
 * Get a portfolio (either by userId or portfolioId)
 *
 * @param   {Object}  payload
 * @param   {String}  [payload.id]
 * @param   {Number}  [payload.userId]
 * @param   {Object}  [payload.params]
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.getPortfolio = function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref5.payload,
        _ref5$onStart = _ref5.onStart,
        onStart = _ref5$onStart === undefined ? function () {} : _ref5$onStart,
        _ref5$onSuccess = _ref5.onSuccess,
        onSuccess = _ref5$onSuccess === undefined ? function () {} : _ref5$onSuccess,
        _ref5$onFail = _ref5.onFail,
        onFail = _ref5$onFail === undefined ? function () {} : _ref5$onFail;

    var _ref6 = payload || {},
        id = _ref6.id,
        userId = _ref6.userId,
        _ref6$params = _ref6.params,
        params = _ref6$params === undefined ? {} : _ref6$params;

    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe3 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe3.ok,
            fail = _conditionalPromiseHe3.fail,
            failIf = _conditionalPromiseHe3.failIf;

        // fail and return if no id or userId


        if (failIf(!(id || userId), { message: 'Neither portfolio nor user id was provided' })) {
            return;
        }

        var getPortfolio = id ? getPortfolioById : getPortfolioByUserId;

        // Make request and handle response
        onStart({ id: id, userId: userId, params: params });
        return getPortfolio(id || userId, params).then(function (response) {
            ok({ portfolio: response.result.portfolio });
        }).catch(fail);
    });
};

/**
 * Add a socialNetwork to a user
 *
 * @param   {Object}  payload
 * @param   {String}  [payload.id]
 * @param   {String}  [payload.status]
 * @param   {String}  [payload.socialNetwork]
 * @param   {Object}  [payload.userPreferences]
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.addSocialNetwork = function () {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref7.payload,
        _ref7$onStart = _ref7.onStart,
        onStart = _ref7$onStart === undefined ? function () {} : _ref7$onStart,
        _ref7$onSuccess = _ref7.onSuccess,
        onSuccess = _ref7$onSuccess === undefined ? function () {} : _ref7$onSuccess,
        _ref7$onFail = _ref7.onFail,
        onFail = _ref7$onFail === undefined ? function () {} : _ref7$onFail;

    var id = payload.id,
        _payload$status = payload.status,
        status = _payload$status === undefined ? STATUS_CONNECTED : _payload$status,
        _payload$userPreferen = payload.userPreferences,
        userPreferences = _payload$userPreferen === undefined ? {} : _payload$userPreferen,
        socialNetwork = payload.socialNetwork;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe4 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe4.ok,
            fail = _conditionalPromiseHe4.fail,
            failIfAny = _conditionalPromiseHe4.failIfAny;

        var validSN = socialNetwork ? SOCIAL_NETWORKS.indexOf(socialNetwork) > -1 : false;
        var possibleErrors = [[!id, { message: 'User id must be specified when updating socialNetwork.' }], [!socialNetwork, { message: 'Required String parameter \'socialNetwork\' is not present' }], [!validSN, { message: 'Social Network ' + socialNetwork + ' is not valid' }]];

        // fail and return if there are errors
        if (failIfAny(possibleErrors)) {
            return;
        }

        // build request payload
        var requestPayload = {
            socialNetwork: defaultSocialNetwork({ name: socialNetwork }),
            status: status, userPreferences: userPreferences
        };

        onStart(requestPayload);
        return addSocialNetwork(id, requestPayload).then(function (response) {
            var _response$result = response.result,
                id = _response$result.id,
                socialNetwork = _response$result.socialNetwork,
                userPreferences = _response$result.userPreferences;

            ok({ id: id, socialNetwork: socialNetwork, userPreferences: userPreferences });
        }).catch(fail);
    });
};

/**
 * Login
 *
 * @param   {Object}  payload
 * @param   {String}  [payload.email]
 * @param   {String}  [payload.password]
 * @param   {String}  [payload.oauth.clientId]
 * @param   {String}  [payload.oauth.state]
 * @param   {String}  [payload.oauth.redirectUri]
 * @param   {String}  [payload.oauth.scope]
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.login = function () {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        host = _ref8.host,
        payload = _ref8.payload,
        _ref8$onStart = _ref8.onStart,
        onStart = _ref8$onStart === undefined ? function () {} : _ref8$onStart,
        _ref8$onSuccess = _ref8.onSuccess,
        onSuccess = _ref8$onSuccess === undefined ? function () {} : _ref8$onSuccess,
        _ref8$onFail = _ref8.onFail,
        onFail = _ref8$onFail === undefined ? function () {} : _ref8$onFail;

    var email = payload.email,
        password = payload.password,
        oauth = payload.oauth;


    return new Promise(function (resolve, reject) {
        var possibleErrors = [[!email, { message: 'Email is required' }], [!password, { message: 'Password is required' }]];

        var _conditionalPromiseHe5 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe5.ok,
            fail = _conditionalPromiseHe5.fail,
            failIfAny = _conditionalPromiseHe5.failIfAny;

        if (failIfAny(possibleErrors)) {
            return;
        }

        onStart(payload);
        fetchWrapper(host + endpoints.sellerLogin(), addHeaders({
            method: 'post',
            body: JSON.stringify(payload)
        })).then(function (response) {
            ok(response.result);
        }).catch(fail);
    });
};

/**
 * Add a socialNetwork to a user
 *
 * @param   {Object}  payload
 * @param   {String}  [payload.sellerId]
 * @param   {String}  [payload.oauth.clientId]
 * @param   {String}  [payload.oauth.state]
 * @param   {String}  [payload.oauth.redirectUri]
 * @param   {String}  [payload.oauth.scope]
 *
 * @param   {Function} [onStart]    - function(args) {} Called when fetch begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when fetch has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if fetch fails
 * @returns {Promise}
 */
exports.oauthCode = function () {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        host = _ref9.host,
        payload = _ref9.payload,
        _ref9$onStart = _ref9.onStart,
        onStart = _ref9$onStart === undefined ? function () {} : _ref9$onStart,
        _ref9$onSuccess = _ref9.onSuccess,
        onSuccess = _ref9$onSuccess === undefined ? function () {} : _ref9$onSuccess,
        _ref9$onFail = _ref9.onFail,
        onFail = _ref9$onFail === undefined ? function () {} : _ref9$onFail;

    var oauth = payload.oauth,
        sellerId = payload.sellerId,
        sellerToken = payload.sellerToken;


    return new Promise(function (resolve, reject) {
        var possibleErrors = [[!sellerId, { message: 'sellerId is required' }], [!oauth.clientId, { message: 'oauth.clientId is required' }], [!oauth.state, { message: 'oauth.state is required' }], [!oauth.redirectUri, { message: 'oauth.redirectUri is required' }], [!oauth.scope, { message: 'oauth.scope is required' }], [!sellerToken, { message: 'sellerToken is required' }]];

        var _conditionalPromiseHe6 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe6.ok,
            fail = _conditionalPromiseHe6.fail,
            failIfAny = _conditionalPromiseHe6.failIfAny;

        if (failIfAny(possibleErrors)) {
            return;
        }

        onStart(oauth);
        fetchWrapper(addParamsToUrl(host + endpoints.oauth(sellerId), { sellerToken: sellerToken }), addHeaders({
            method: 'post',
            body: JSON.stringify(oauth)
        })).then(function (response) {
            ok(response.result);
        }).catch(fail);
    });
};